module.exports = __webpack_public_path__ + "static/media/share-ic-blue.b08e6e6c.svg";